export const getEmail = state => state.user.email;
export const getToken = state => state.user.token;
export const getIsLoggined = state => state.user.isLoggined;
